module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/seating_desktop-255e6bdf095f1894183c27d56612f9e1.png";